import * as Yup from 'yup'

export const newPasswordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])(?=.{10,})/

export const passwordValidationSchema = Yup.object().shape({
  oldPassword: Yup.string().required('Must enter your current password'),
  newPassword: Yup.string()
    .matches(
      newPasswordRegex,
      'New password does not satisfy all conditions above.'
    )
    .required('Required'),
  confirmPassword: Yup.string()
    .required('Required')
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
})
